export const SET_PREVIOUS_PAGE = "SET_PREVIOUS_PAGE"
